var map = {
	"./angle.svg": "03ed",
	"./arrow.svg": "a3fa",
	"./check.svg": "cc69",
	"./cloud.svg": "5afb",
	"./content.svg": "c54e",
	"./cup.svg": "bc84",
	"./logo-vkplay.svg": "2f2d",
	"./mac.svg": "c0f3",
	"./more.svg": "a473",
	"./new.svg": "8984",
	"./ok-icon.svg": "b21f",
	"./people.svg": "8c06",
	"./smile.svg": "8b56",
	"./speech-bubble.svg": "5e30",
	"./streams.svg": "d230",
	"./vk-icon.svg": "8c82",
	"./windows.svg": "0371"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef4d";